import { Helmet } from 'react-helmet-async';
import { transformImageUrl } from '../utils/imageTransform';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  siteName = 'TaxiUbr Thailand'
}) => {
  const siteUrl = 'https://www.taxiubr.com'; // Domain หลัก - ใช้ www
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  
  // Transform image URLs for SEO (OG image standard size: 1200x630)
  const getTransformedImageUrl = (imgPath) => {
    if (!imgPath) {
      // Default image
      const transformedPath = transformImageUrl('/logo-black-circle.png', 'width=1200,height=630,fit=cover,quality=85,format=auto');
      return transformedPath.startsWith('http') ? transformedPath : `${siteUrl}${transformedPath}`;
    }
    
    // If image is already a full URL, extract the path for transformation
    let imagePath = imgPath;
    if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) {
      try {
        const urlObj = new URL(imgPath);
        imagePath = urlObj.pathname;
      } catch (e) {
        // If URL parsing fails, use original
        imagePath = imgPath;
      }
    }
    
    const transformedPath = transformImageUrl(imagePath, 'width=1200,height=630,fit=cover,quality=85,format=auto');
    // Ensure full URL (transformImageUrl returns relative paths)
    return transformedPath.startsWith('http') ? transformedPath : `${siteUrl}${transformedPath}`;
  };
  
  const ogImage = getTransformedImageUrl(image);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="th_TH" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="language" content="Thai" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="TaxiUbr Thailand" />
    </Helmet>
  );
};

export default SEO;


